<mat-card appearance="outlined" *ngIf="!!dynamicContent" class="publishing">
  <h2>{{ 'dynamicContent.publishingConfig' | translate }}</h2>
  <ibex-checkbox [title]="('general.active' | translate) + ' (' + ('dynamicContent.activeHint' | translate) + ')'"
                 [checked]="dynamicContent.published" (click)="dynamicContent.published = $event.val" class="published"></ibex-checkbox>
  <div class="content">
    <div class="inner-content">
      <div class="interval">
        <h3>{{ 'dynamicContent.publishingPeriod' | translate }}</h3>
        <mat-form-field class="minimize-height-sm">
          <input [(ngModel)]="dynamicContent.publishStart" [matDatepicker]="startPicker" [max]="dynamicContent.publishEnd" matInput placeholder="{{'dynamicContent.startDate' | translate}}">
          <mat-datepicker-toggle [for]="startPicker" matPrefix>
            <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="minimize-height-sm">
          <input [(ngModel)]="dynamicContent.publishStartTime" matInput placeholder="{{'dynamicContent.startTime' | translate}}">
          <button (click)="openTimePicker(dynamicContent.publishStartTime, 'startPublishing')" mat-icon-button matPrefix>
            <mat-icon>access_time</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field class="minimize-height-sm">
          <input [(ngModel)]="dynamicContent.publishEnd" [matDatepicker]="endPicker" [min]="dynamicContent.publishStart" matInput
                 placeholder="{{'dynamicContent.endDate' | translate}}">
          <mat-datepicker-toggle [for]="endPicker" matPrefix>
            <mat-icon matDatepickerToggleIcon>calendar_month</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="minimize-height-sm">
          <input [(ngModel)]="dynamicContent.publishEndTime" matInput placeholder="{{'dynamicContent.endTime' | translate}}">
          <button (click)="openTimePicker(dynamicContent.publishEndTime, 'endPublishing')" mat-icon-button matPrefix>
            <mat-icon>access_time</mat-icon>
          </button>
        </mat-form-field>
        <mat-radio-group [(ngModel)]="dynamicContent.daily" class="daily-group">
          <mat-radio-button [value]="false">{{ 'dynamicContent.dailyThrough' | translate }}</mat-radio-button>
          <mat-radio-button [value]="true">{{ 'dynamicContent.dailyDaily' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="days" *ngIf="weekdays">
        <h3>{{ 'dynamicContent.daySelection' | translate }}</h3>
        <div class="days-container">
          <ibex-checkbox *ngFor="let i of weekdayArray" (click)="updateDynamicContentDays($event, i)"
                         [title]="'general.days.' + i | translate" [checked]="weekdays[i]"></ibex-checkbox>
        </div>
      </div>
    </div>
    <button (click)="resetPublishing()" class="ibexfusion-raised-button small" mat-button>{{ 'general.reset' | translate }}</button>
  </div>
</mat-card>
